import React, { useCallback, useState } from 'react';
import { Api } from 'laravel-request';
import { useAppDispatch, useAppSelector } from '#app/hooks/useAppStore';
import { getActiveTags } from '#app/actions/interface';
import { useActives } from '#app/pages/IncomeAndExpenses/components/ActivesContext';
import { InputContainer, MultipleSearch } from 'finform';

const SearchTag = ({ item, subcategoryType, tags, finishEdit }) => {
  const dispatch = useAppDispatch();
  const client = useAppSelector((s) => s.interfaceComponents.client);
  const getActiveTagsFn = useCallback(() => dispatch(getActiveTags()), [dispatch]);
  const { setPreparedActives } = useActives();

  const [searchTag, setSearchTag] = useState('');

  const storeTagRelation = (item) => {
    Api.post('active-tag-relation', 'store', {
      tags: item.tag_items,
      active_id: item.id,
    })
      .withoutNotify()
      .call((_response) => {
        getActiveTagsFn();
      });
  };

  const storeTag = (item, value, callback) => {
    Api.post('active-tag', 'store', {
      user_id: client ? client.id : '',
      name: value,
      type_id: subcategoryType,
    })
      .withoutNotify()
      .call((response) => {
        if (response.meta && response.meta.id) {
          setPreparedActives(
            (prevActives) => {
              return prevActives.map((year) => ({
                ...year,
                months: year.months.map((month) => ({
                  ...month,
                  dates: month.dates.map((date) => ({
                    ...date,
                    items: date.items.map((operation) => {
                      if (item.id === operation.id) {
                        return {
                          ...operation,
                          tag_items: [
                            ...operation.tag_items,
                            { value: response.meta.id, label: value },
                          ],
                        };
                      }
                      return operation;
                    }),
                  })),
                })),
              }));
            },
            () => {
              callback();
            }
          );
        }
      });
  };

  const updateTagItems = (newValue) => {
    setPreparedActives((prevActives) => {
      return prevActives.map((year) => ({
        ...year,
        months: year.months.map((month) => ({
          ...month,
          dates: month.dates.map((date) => ({
            ...date,
            items: date.items.map((operation) => {
              if (item.id === operation.id) {
                return {
                  ...operation,
                  tag_items: newValue,
                };
              }
              return operation;
            }),
          })),
        })),
      }));
    });
  };

  const handleOnChange = (newValue, actionMeta) => {
    switch (actionMeta.action) {
      case 'select-option':
      case 'remove-value':
      case 'pop-value':
        updateTagItems(newValue);
        break;
      default:
        break;
    }
  };

  return (
    <div
      style={{
        alignItems: 'center',
        display: 'flex',
      }}
    >
      <InputContainer
        style={{
          width: '100%',
          borderRadius: '8px',
          padding: '5px',
          background: '#fff',
          boxShadow: 'rgb(38 38 38 / 4%) 0px 1px 2px, rgb(38 38 38 / 16%) 0px 4px 8px',
        }}
      >
        <MultipleSearch
          id={'incomes-and-expenses-select-tag-' + item.id}
          options={tags}
          values={item.tag_items}
          search={searchTag}
          onSearch={setSearchTag}
          allowAdd={true}
          onChange={handleOnChange}
          handleCreate={(newValue) => {
            storeTag(item, newValue, () => {});
          }}
          onBlur={() => {
            storeTagRelation(item);
            finishEdit();
          }}
        />
      </InputContainer>
    </div>
  );
};

export default SearchTag;
